import { ReactNode, createContext, useContext } from 'react';
import { useMemoizedArray } from '../hooks';

interface SelectedLocationProviderProps {
  children: ReactNode;
  locationId: string | undefined | (string | undefined)[];
}

export const selectedLocationContext = createContext<string[] | undefined>(undefined);

export const SelectedLocationProvider = ({ children, locationId }: SelectedLocationProviderProps) => {
  const locationIds = useMemoizedArray(locationId);

  return <selectedLocationContext.Provider value={locationIds}>{children}</selectedLocationContext.Provider>;
};

export const useSelectedLocationContext = () => {
  const locationId = useContext(selectedLocationContext);
  return locationId;
};
